// AI Generated Component
import { Component, Input } from '@angular/core';
import { PAGE_FIX_EVENT } from '@client/app/modules/page-fix/constants/page-fix-event';
import { MonEventService } from '@monsido/services/mon-event/mon-event.service';

@Component({
    selector: 'page-fix-form-wizard-container-footer-go-to-options',
    templateUrl: './go-to-options.component.html',
    standalone: false,
})
export class PageFixFormWizardContainerFooterGoToOptionsComponent {
    @Input() pageFixApplied?: boolean | undefined;
    @Input() view!: any;

    constructor (private monEventService: MonEventService) {}

    goToView (): void {
        this.monEventService.run(PAGE_FIX_EVENT.FORM_REQUEST_GO_TO_VIEW, this.view);
    }
}
